import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const updateReadyToCheckoutSelector = createSelector(testTargetOffersSelector, offers => offers.updateReadyToCheckout || Empty.Object);

export { updateReadyToCheckoutSelector };
